import React from 'react';

import { FormattedMessage } from 'react-intl';

import S from '../S';
import styles from './ActivityFieldInfo.styles.less';

function LinkValue({ href, label }: { href: string; label: string }) {
  try {
    const cleanUrl = new URL(href).toString();
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={styles.linkField}
        href={cleanUrl}
      >
        {label}
      </a>
    );
  } catch {
    return <>{href}</>;
  }
}

const ActivityFieldInfo = ({
  title = '',
  translationKey,
  value,
  className,
  nextLine,
  asLink,
  link,
}: {
  title: React.ReactNode;
  translationKey?: 'location' | 'starts' | 'end';
  value?: string | number;
  className?: string;
  nextLine?: boolean;
  asLink?: boolean;
  link?: string;
}) => {
  const renderLink = link && asLink;

  return (
    <div className={className}>
      <S size="4" inline bold colon>
        {translationKey ? (
          <FormattedMessage id={`shared.ActivityFieldInfo.${translationKey}`} />
        ) : (
          title
        )}
      </S>
      {nextLine && <br />}
      &nbsp;
      {renderLink ? (
        <LinkValue href={link} label={value as string} />
      ) : (
        <div
          className={styles.html}
          dangerouslySetInnerHTML={{ __html: value as string }}
        />
      )}
    </div>
  );
};

export default ActivityFieldInfo;
